<div class="identi-page-wrapper pb-5">
  <app-product-hero
    [level]="productLevels.PitPat"
    title="PitPat Dog GPS Tracker"
    subtitle="Now available to buy separately <br><br> Add to an identibase+ or identialert plan for the ultimate protection package"
    (onBuyClick)="buyPitPat()"
    [compareVisible]="false"
    [levelsVisible]="false"
  ></app-product-hero>

  <div class="row py-4 light-background mx-0">
    <div class="col-12 text-center px-3">
      <div
        class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center"
      >
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/pitpat/battery-life-badge.png"
            alt="one-plan"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0"><b>No subscription </b></p>
            to find your dog
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/pitpat/live-location-badge.svg"
            alt="live-location"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0"><b>Live location</b></p>
            from any distance
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/pitpat/activity-monitoring-badge.svg"
            alt="activity-monitoring"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0"><b>Award-winning</b></p>
            activity monitoring
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/pitpat/waterproof-badge.png"
            alt="waterproof"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0"><b>100% waterproof</b></p>
            even in the sea
          </h6>
        </div>
      </div>
      <button
        (click)="buyPitPat()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
      >
        Buy now
      </button>
    </div>
  </div>

  <div class="row py-4 light-background mx-0">
    <div class="col-10 col-xl-8 offset-1 offset-xl-2 text-center px-3">
      <h6 class="my-2">
        With the PitPat GPS Tracker not only can you keep tabs on your dog at
        all times, but rest assured that you can locate your dog in the event of
        them taking an unexpected solo adventure.
        <br /><br />
      </h6>
      <h6 class="my-2">
        If you have taken up an identibase+ or an identialert plan, you can now
        add real-time location tracking with a PitPat GPS Tracker to your plan
        for £129. What's more, if you're already an identifind plan holder, but
        looking for an additional tracker, you too can purchase additional
        PitPat GPS trackers for the same price.
        <br /><br />
      </h6>
      <h6 class="mb-2 mt-1">
        Don't hold a plan with us? You're still able to track your dog's
        location with a PitPat GPS Tracker without taking out one of our plans,
        and instead pay a one-off fee of £149 to get your tracker.
      </h6>
      <button
        (click)="buyPitPat()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
      >
        Buy now
      </button>
    </div>
  </div>

  <div class="row pt-5 mid-background mx-0">
    <div class="col-10 col-xl-8 offset-1 offset-xl-2 px-3">
      <div class="row mb-3">
        <div class="col-12">
          <h3>Complete peace of mind with PitPat</h3>
          <h5>
            Small and lightweight, the PitPat Dog GPS Tracker simply attaches to
            their collar - so you can stay connected wherever they go.
          </h5>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-sm-12 col-md-12 col-lg-4 my-2 video-container">
          <iframe
            class="video"
            [src]="pitPatAdVideoUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-4 my-2">
          <img
            class="image"
            src="/assets/images/identibase/identiFind/pitpat.jpg"
            alt="pitpat"
          />
        </div>
        <div class="col-sm-12 col-md-12 col-lg-4 my-2 video-container">
          <iframe
            class="video"
            [src]="unboxingVideoUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>

  <div class="row py-4 light-background mx-0">
    <div class="col-12 text-center px-3">
      <h3 class="mt-2 mb-3">What’s included?</h3>
      <div
        class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center"
      >
        <div class="col text-center my-2">
          <img
            class="big-feature-icon"
            src="/assets/images/identibase/pitpat/tracker-icon.png"
            alt="tracker"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0">Small and light</p>
            dog GPS tracker
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="big-feature-icon"
            src="/assets/images/identibase/pitpat/phone-icon.png"
            alt="phone-icon"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0">Easy to use app to track</p>
            your pet and their progress
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="big-feature-icon"
            src="/assets/images/identibase/pitpat/wireless-charger-icon.png"
            alt="wireless-charging"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0">Wireless charger for easy</p>
            charging
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="big-feature-icon"
            src="/assets/images/identibase/pitpat/no-hidden-fees-icon.png"
            alt="no-hidden-fees"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0">No subscription to</p>
            find your dog
          </h6>
        </div>
      </div>
      <button
        (click)="buyPitPat()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
      >
        Buy now
      </button>
    </div>
  </div>
</div>
